module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withPropsFromContext = exports.getContextualizer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getContextualizer = exports.getContextualizer = function getContextualizer(propTypes) {
	  return _react2.default.createClass({
	    displayName: 'ContextProps',
	
	    childContextTypes: propTypes,
	
	    getChildContext: function getChildContext() {
	      var _this = this;
	
	      var props = Object.keys(this.props).reduce(function (x, key) {
	        if (key !== 'children') {
	          x[key] = _this.props[key];
	        }
	
	        return x;
	      }, {});
	
	      return props;
	    },
	    render: function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.children
	      );
	    }
	  });
	};
	
	var withPropsFromContext = exports.withPropsFromContext = function withPropsFromContext(Component, propList) {
	  return _react2.default.createClass({
	    displayName: Component.displayName || Component.name,
	
	    contextTypes: propList.reduce(function (x, prop) {
	      x[prop] = _react.PropTypes.any;
	      return x;
	    }, {}),
	
	    render: function render() {
	      var _this2 = this;
	
	      var props = _extends({}, propList.reduce(function (x, prop) {
	        x[prop] = _this2.context[prop];
	
	        return x;
	      }, {}), this.props);
	
	      return _react2.default.createElement(Component, props);
	    }
	  });
	};

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = require("react");

/***/ }
/******/ ]);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-context-props/dist/index.js
// module id = 984
// module chunks = 0